import Button from 'components/Button'
import React from 'react'
import ReactModal from 'react-modal'
import { FormattedMessage } from 'react-intl'

const customStylesWarning = {
  content: {
    padding: '1rem',
    width: '650px',
    height: '300px',
    borderRadius: '8px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    pointerEvents: 'auto',
    transform: 'translate(-50%, -50%)',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  overlay: {
    backgroundColor: 'transparent',
    pointerEvents: 'none',
    zIndex: 1000
  }
}

const separatorStyle = {
  width: '100%',
  height: '1px',
  backgroundColor: '#ccc',
  margin: '10px 0'
}

const buttonContainerStyle = {
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
  justifyContent: 'center'
}

const NonQualifyWarningModal = ({ isOpen, toggleModal }) => {
  return (
    <ReactModal isOpen={isOpen} style={customStylesWarning}>
      <div style={{ textAlign: 'center' }}>
        <h2>
          <FormattedMessage id="warningModalHeaderSpecies" />
        </h2>
        <div style={separatorStyle}></div>
        <p style={{
          fontSize: '16px',
          lineHeight: '34px',
          margin: '20px',
          fontWeight: '400',
          textAlign: 'left'
        }}>
          <FormattedMessage id="nonQualifyReasonWarning" onClick={() => {
            return toggleModal(false)
          }} />
        </p>
        <div style={buttonContainerStyle}>
          <Button
            type='secondary'
            height='40px'
            marginTop='1rem'
            padding='2rem'
            onClick={() => {
              return toggleModal(false)
            }}
          >
            <FormattedMessage id="Continue" />
          </Button>
        </div>
      </div>
    </ReactModal>
  )
}

export default NonQualifyWarningModal
